/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeletePartnerActivitiesRequest
 */
export interface DeletePartnerActivitiesRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof DeletePartnerActivitiesRequest
     */
    activityIds: Array<number>;
}

/**
 * Check if a given object implements the DeletePartnerActivitiesRequest interface.
 */
export function instanceOfDeletePartnerActivitiesRequest(value: object): value is DeletePartnerActivitiesRequest {
    if (!('activityIds' in value) || value['activityIds'] === undefined) return false;
    return true;
}

export function DeletePartnerActivitiesRequestFromJSON(json: any): DeletePartnerActivitiesRequest {
    return DeletePartnerActivitiesRequestFromJSONTyped(json, false);
}

export function DeletePartnerActivitiesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeletePartnerActivitiesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'activityIds': json['activityIds'],
    };
}

export function DeletePartnerActivitiesRequestToJSON(json: any): DeletePartnerActivitiesRequest {
    return DeletePartnerActivitiesRequestToJSONTyped(json, false);
}

export function DeletePartnerActivitiesRequestToJSONTyped(value?: DeletePartnerActivitiesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activityIds': value['activityIds'],
    };
}

